export const SPINEBOY_PRO_SKELETON_ASSET_ID = 'spineboy-pro-skeleton';
export const SPINEBOY_PRO_ATLAS_ASSET_ID = 'spineboy-pro-atlas';

export const SPINEBOY_PRO_SKELETON_SRC = '/assets/images/spines/spineboy-pro.json';
export const SPINEBOY_PRO_ATLAS_SRC = '/assets/images/spines/spineboy-pro.atlas';


